var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4807BBE3-B4CA-4AE2-A558-D448CF042099") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Virtual-Appt-Scheduling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Requirements-(Step-2)",
    transform: "translate(-758.000000, -1181.000000)",
    fill: "#2E853F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pick-who-to-schedule-with",
    transform: "translate(202.000000, 1022.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accordian/Closed",
    transform: "translate(41.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task_alt_black_24dp",
    transform: "translate(515.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,2.226 L6.013,10.22 L3.045,7.252 L4.032,6.265 L6.013,8.246 L13.013,1.246 L14,2.226 Z M12.453,5.754 C12.544,6.153 12.6,6.573 12.6,7 C12.6,10.094 10.094,12.6 7,12.6 C3.906,12.6 1.4,10.094 1.4,7 C1.4,3.906 3.906,1.4 7,1.4 C8.106,1.4 9.128,1.722 9.996,2.275 L11.004,1.267 C9.87,0.469 8.491,0 7,0 C3.136,0 0,3.136 0,7 C0,10.864 3.136,14 7,14 C10.864,14 14,10.864 14,7 C14,6.167 13.846,5.369 13.58,4.627 L12.453,5.754 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.34643f113189a0eabe757cdc962bb333.svg";
export { ForwardRef as ReactComponent };